export const OrderIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={19}
    fill="none"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeWidth={1.4}
      d="M12.75 3.5h-7.5A1.5 1.5 0 0 0 3.75 5v9.75a1.5 1.5 0 0 0 1.5 1.5h7.5a1.5 1.5 0 0 0 1.5-1.5V5a1.5 1.5 0 0 0-1.5-1.5Z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={1.4}
      d="M6.75 7.25h4.5m-4.5 3h4.5m-4.5 3h3"
    />
  </svg>
);
